module.exports = __webpack_public_path__ + "static/Matthew Black.59a2696b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Matthew Black.jpg
// module id = 1222
// module chunks = 6166952557895